export default __webpack_public_path__ + "static/media/avi.713323f9.jpg";